import Joueur from "@/firebase/tirage2/Joueur.js"
export default class Equipe {
    ggGagnes = 0;
    options= null;
    numeroRestantJoueurs = null;
    nbJoueursParEquipe = null;
    indexPartie = null;
    joueurs = null;
    terrain = null;
    score = {
        contre: null,
        joueurs: null
    };
    triplette = null;
    exists = null;
    dataJoueurs = {
        joueurs: {
            J1: null,
            J2: null,
            J3: null
        },
        contre: {
            J1: null,
            J2: null,
            J3: null
        }
    }
    json = {
        joueurs: {
            J1: null,
            J2: null,
            J3: null
        },
        contre: {
            J1: null,
            J2: null,
            J3: null
        },
        state: "WAITING",
        score: {
            contre : null,
            joueur : null
        },
        ggGagnes: 0
    }
    state = "WAITING";
    
    constructor(indexPartie, options, numeroRestantJoueurs, joueurs) {
       
        if (typeof(indexPartie) != "undefined") {
            this.numeroRestantJoueurs = numeroRestantJoueurs;
            this.options = options;
            this.indexPartie = indexPartie;
            this.joueurs = joueurs;
            this.nbJoueursParEquipe = options.nbJoueursParEquipe;
        }
    }
    checkErrorFormeGG(numeroContre, type) {
        if (this.dataJoueurs[type].J1==null)
            return true;
        else {
            var numeroJoueur = this.dataJoueurs[type].J1.numero;
            var error = false;
            for (var indexPartie = this.indexPartie-1;indexPartie>=0;indexPartie--) {
                if ((this.joueurs[numeroJoueur].parties[indexPartie].contre.findIndex(elt=>elt === numeroContre) != -1) && !error)
                    error = true;
            }
            return error;
        }
    }
    checkError () {
        var returnError = true;
        for (var key in this.dataJoueurs) {
            for (var joueur in this.dataJoueurs[key]) {
                if (this.dataJoueurs[key][joueur] != null)
                    returnError = this.joueurs[this.dataJoueurs[key][joueur].numero].checkError(this.indexPartie) && returnError;
            }
        }
        return returnError
    }
    traiterError(numero) {
        var numeroFind;
        var error = true;
        if (typeof(numero) == "undefined")
            numeroFind = this.dataJoueurs.joueurs.J1.numero;
        else    
            numeroFind = numero;

        for(var key in this.dataJoueurs)
            for (var joueur in this.dataJoueurs[key]) {
                error = this.dataJoueurs[key][joueur].joueurs.indexOf(numeroFind) != -1
            }

    }
    getNb(vs) {
        var nb = 0;
        for (var joueur in this.dataJoueurs[vs]) 
            nb = this.dataJoueurs.joueurs[joueur] != null ? (nb + 1) : nb ;
        return nb;

    }
    getJoueurNotNull(vs) {
        var joueurReturn = 'J1';
        var findJoueur = false;
        for (var joueur in this.dataJoueurs[vs]) {
            if (!findJoueur && this.dataJoueurs[vs][joueur]!=null) {
                joueurReturn = joueur;
                findJoueur = true;
            }
        } 
        return joueurReturn;
    }
    getJoueurNull(vs) {
        var joueurReturn = null;
        for (var joueur in this.dataJoueurs[vs]) {
            if (joueurReturn == null && this.dataJoueurs[vs][joueur]==null)
                joueurReturn = joueur;
        } 
        return joueurReturn;
    }
    getNbJOUEURS () {
        var nb = 0;
        for (var joueur in this.dataJoueurs.joueurs) 
            nb = this.dataJoueurs.joueurs[joueur] != null ? (nb + 1) : nb ;
        return nb;

    }
    getNbCONTRE () {
        var nb = 0;
        for (var joueur in this.dataJoueurs.contre)
            nb = this.dataJoueurs.contre[joueur] != null ? (nb + 1) : nb ;
        return nb;
    }
    reinitJoueurs(joueurs) {
        // REMET A JOUR LES JOUEURS UNIQUEMENT DE L EQUIPE !!!!
        var joueursAMAJ = [];
       
        for (var key in this.dataJoueurs) {
            for (var joueur in this.dataJoueurs[key]) {
                if (this.dataJoueurs[key][joueur] != null) {
                    if (key == "joueurs") {
                        
                        joueurs[this.dataJoueurs[key][joueur].numero].pushAmis(this.dataJoueurs["joueurs"], this.indexPartie);
                        joueurs[this.dataJoueurs[key][joueur].numero].pushContre(this.dataJoueurs["contre"], this.indexPartie);
                        joueursAMAJ.push(joueurs[this.dataJoueurs[key][joueur].numero])
                    }
                    else {
                        joueurs[this.dataJoueurs[key][joueur].numero].pushAmis(this.dataJoueurs["contre"], this.indexPartie);
                        joueurs[this.dataJoueurs[key][joueur].numero].pushContre(this.dataJoueurs["joueurs"], this.indexPartie);
                        joueursAMAJ.push(joueurs[this.dataJoueurs[key][joueur].numero])
                    }
                }
            }
        }
        
        this.checkError();
    }
    init() {
        var gagne = null;
        for (var key in this.dataJoueurs) {
            var nbJoueur = 0;
            var joueurJ1 = null;
            var goFind = true;
            var forcage;
            if (this.numeroRestantJoueurs.length<20)
                forcage = 1;
            for (var joueur in this.dataJoueurs[key]) {
                if (this.numeroRestantJoueurs.length>0) {
                    goFind = nbJoueur < this.nbJoueursParEquipe;
                    if (goFind) {
                        
                        var joueurFind = Joueur.findJoueur( this.numeroRestantJoueurs, this.joueurs, this.dataJoueurs ,key, this.options, gagne, this.numeroRestantJoueurs, forcage);
                      
                        this.dataJoueurs[key][joueur] = joueurFind;
                        if (joueurFind != null) {
                            var indexNumero = this.numeroRestantJoueurs.indexOf(joueurFind.numero);
                            this.numeroRestantJoueurs.splice(indexNumero, 1);
                            gagne = joueurFind.gagnes;
                        }
                            nbJoueur ++;
                    }
                }
            }            
        }
        this.reinitJoueurs(this.joueurs);
        
    }
    
    getNumeroRestantJoueurs() {
        return this.numeroRestantJoueurs
    }
    getJSON() {
        var json = JSON.parse(JSON.stringify(this.json));
        for (var key in json) {
            if (key == "contre" || key == "joueurs")
                for (var joueur in json[key]) {
                    if (this.dataJoueurs[key][joueur] != null ) {
                        json[key][joueur] = {
                                numero : this.dataJoueurs[key][joueur].numero,
                                error : this.dataJoueurs[key][joueur].error,
                                errorDetail : this.dataJoueurs[key][joueur].errorDetail,
                                parties : this.dataJoueurs[key][joueur].parties,
                                gagnesByPartie: null
                        }
                        if (typeof(this.joueurs[json[key][joueur].numero])!="undefined") {
                            if (typeof(this.joueurs[json[key][joueur].numero].gagnesByPartie)!="undefined") {
                                json[key][joueur].gagnesByPartie = this.joueurs[json[key][joueur].numero].gagnesByPartie;
                                json[key][joueur].errorDetail = this.joueurs[json[key][joueur].numero].errorDetail;
                                json[key][joueur].error = this.joueurs[json[key][joueur].numero].error;
                            }
                        }
                        
                    }
                        
                }
            json.score = this.score;
            if (json.score.joueurs != null)
                json.state = "FINISH";
            else
                json.state = this.state;
            json.ggGagnes = this.ggGagnes;
            json.triplette = this.triplette;
            json.exists = this.exists;
            json.terrain = this.terrain;
        }
        return JSON.parse(JSON.stringify(json));
    }
    
    alreadyNbJoueurs(key, nbJoueurs) {
        var findTriplette = false;
        for (var joueur in this.dataJoueurs[key]) {
            if (this.dataJoueurs[key][joueur] != null) {
                var joueurCurrent = this.dataJoueurs[key][joueur];
                if (!findTriplette) {
                    
                    this.joueurs[joueurCurrent.numero].parties.forEach((partie)=>{
                        if (!findTriplette)
                            findTriplette = partie.joueurs.length == nbJoueurs;
                    })
                } 
            }
        }
        return findTriplette;
    }
    static findJoueurToCompleteTriplette(equipe, equipes, indexEquipe) {
        var objectReturn = {
            indexEquipe: null,
            key: null,
            joueur: null
        }
        var findEquipe = false;
        if (typeof(indexEquipe) == "undefined")
            var indexEquipeLocal = equipes.length - 1;
        else {
            var indexEquipeLocal = indexEquipe;
        }
        
        if (indexEquipeLocal == -1) {
            var indexEquipeError =  equipes.length - 1;
            var loopWhile = true;
            var extreme = false;
           
            while (loopWhile) {
                if (equipes[indexEquipeError].getNbJOUEURS() == 3) {
                    objectReturn.indexEquipe = indexEquipeError;
                    objectReturn.joueur = "J3";
                    objectReturn.key = "joueurs";
                    findEquipe = true;
                }
                else if (equipes[indexEquipeError].getNbCONTRE() == 3) {
                    objectReturn.indexEquipe = indexEquipeError;
                    objectReturn.joueur = "J3";
                    objectReturn.key = "contre";
                    findEquipe = true;
                }
                else if (extreme) {
                    for (var key in equipes[indexEquipeError].dataJoueurs) {
                        for (var joueurLoop in equipes[indexEquipeError].dataJoueurs[key]) {
                            if (!findEquipe && equipes[indexEquipeError].dataJoueurs[key][joueurLoop] != null) {
                                objectReturn.indexEquipe = indexEquipeError;
                                objectReturn.joueur = joueurLoop;
                                objectReturn.key = key;
                                findEquipe = true;
                            }
                        }
                    }
                }
                indexEquipeError -- ;
                if (indexEquipeError == -1) {
                    if (extreme)
                        loopWhile = false;
                    else {
                        indexEquipeError = equipes.length - 1;
                        extreme = true;
                    }
                }
            }
        }
        else {
            var testNBJOUEURS = equipes[indexEquipeLocal].getNbJOUEURS() == 3 && equipes[indexEquipeLocal].getNbCONTRE() == 3;
        
            if (testNBJOUEURS) {
                for (var key in equipes[indexEquipeLocal].dataJoueurs)
                    for (var joueurLoop in equipes[indexEquipeLocal].dataJoueurs[key]) {
                        if (!findEquipe) {
                            var joueur = equipes[indexEquipeLocal].dataJoueurs[key][joueurLoop];
                            if (Joueur.validAMI (joueur, equipe.dataJoueurs["joueurs"]) && 
                                Joueur.validCONTRE (joueur, equipe.dataJoueurs["contre"])) {
                                    if (!equipes[indexEquipeLocal].alreadyNbJoueurs(key, 1)) {
                                      
                                        objectReturn.indexEquipe = indexEquipeLocal;
                                        objectReturn.joueur = joueurLoop;
                                        objectReturn.key = key;
                                        findEquipe = true;
                                    }
                            }
                        }
                    }
            }
        }
        
        
        if (findEquipe)
            return objectReturn;
        else
            return this.findJoueurToCompleteTriplette(equipe, equipes, indexEquipeLocal - 1);
    }
    static findEquipeForTriplette(joueur, equipes, indexEquipe) {
        
        var objectReturn = {
            indexEquipe: null,
            key: null,
            joueur: null
        }
        
        var findEquipe = false;
        if (typeof(indexEquipe) == "undefined")
            var indexEquipeLocal = equipes.length - 1;
        else {
            var indexEquipeLocal = indexEquipe;
            
        }
        if (indexEquipeLocal == -1) {
            
            var indexEquipeError = 0;
            var loopWhile = true;
            var extreme = false;
           
            while (loopWhile) {
                
                if (!extreme && Joueur.validAMI (joueur, equipes[indexEquipeError].dataJoueurs["joueurs"]) && 
                        Joueur.validCONTRE (joueur, equipes[indexEquipeError].dataJoueurs["contre"])) {
                    if (equipes[indexEquipeError].getNbJOUEURS() == 2) {
                        if (!equipes[indexEquipeError].alreadyNbJoueurs("joueurs", 2) 
                                && !equipes[indexEquipeError].alreadyNbJoueurs("contre", 2)) {
                            loopWhile = false;
                            objectReturn.indexEquipe = indexEquipeError;
                            objectReturn.key = "joueurs";
                            objectReturn.joueur = "J3";
                        }
                    }
                }
                if (!extreme && loopWhile && Joueur.validAMI (joueur, equipes[indexEquipeError].dataJoueurs["contre"]) && 
                            Joueur.validCONTRE (joueur, equipes[indexEquipeError].dataJoueurs["joueurs"])) {
                    if (equipes[indexEquipeError].getNbJOUEURS() == 2) {
                        if (!equipes[indexEquipeError].alreadyNbJoueurs("joueurs", 2) 
                                && !equipes[indexEquipeError].alreadyNbJoueurs("contre", 2)) {
                            loopWhile = false;
                            objectReturn.indexEquipe = indexEquipeError;
                            objectReturn.key = "contre";
                            objectReturn.joueur = "J3";
                        }
                    }
                }

                if (extreme && equipes[indexEquipeError].getNbJOUEURS() == 2) {
                    
                    loopWhile = false;
                    objectReturn.indexEquipe = indexEquipeError;
                    objectReturn.key = "joueurs";
                    objectReturn.joueur = "J3";
                    joueur.error = 3;
                }
                if (extreme  && loopWhile && equipes[indexEquipeError].getNbCONTRE() == 2) {
                    loopWhile = false;
                    objectReturn.indexEquipe = indexEquipeError;
                    objectReturn.key = "contre";
                    objectReturn.joueur = "J3";
                    joueur.error = 3;
                }
                indexEquipeError ++ ;
                if (indexEquipeError >= equipes.length) {
                    if (extreme)
                        loopWhile = false;
                    else {
                        indexEquipeError = 0;
                        extreme = true;
                    }
                }
                    
                

            }
            findEquipe = !loopWhile;

        }
        else {
            
            if (equipes[indexEquipeLocal].getNbJOUEURS() == 2 && equipes[indexEquipeLocal].getNbCONTRE() == 3) {
             
                // Après on va vérifier si les joueurs de cette équipe ne sont pas déjà recontré
                  /*  if (Joueur.validAMI (joueur, equipes[indexEquipeLocal].dataJoueurs["joueurs"]) && 
                        Joueur.validCONTRE (joueur, equipes[indexEquipeLocal].dataJoueurs["contre"])) {
                            
                            
                            if (!equipes[indexEquipeLocal].alreadyNbJoueurs("joueurs", 2) 
                                && !equipes[indexEquipeLocal].alreadyNbJoueurs("contre", 2)) {*/
                objectReturn.indexEquipe = indexEquipeLocal;
                objectReturn.joueur = 'J3';
                objectReturn.key = 'joueurs';
                findEquipe = true;
            
                    
                    
                
            }
            if (!findEquipe && equipes[indexEquipeLocal].getNbJOUEURS() == 3 && equipes[indexEquipeLocal].getNbCONTRE() == 2) {
                    
                   /* if (Joueur.validAMI (joueur, equipes[indexEquipeLocal].dataJoueurs["contre"]) && 
                            Joueur.validCONTRE (joueur, equipes[indexEquipeLocal].dataJoueurs["joueurs"])) {
                                // On va vérifier si les joueurs de cette équipe n'ont pas déjà fait une triplette
                            
                                if (!equipes[indexEquipeLocal].alreadyNbJoueurs("joueurs", 2) 
                                    && !equipes[indexEquipeLocal].alreadyNbJoueurs("contre", 2)) {*/
                objectReturn.indexEquipe = indexEquipeLocal;
                objectReturn.joueur = 'J3';
                objectReturn.key = 'contre';
                findEquipe = true;
                        
                        
                }

        }      
        if (findEquipe)
            return objectReturn;
        else
            return this.findEquipeForTriplette(joueur, equipes, indexEquipeLocal - 1);
            
    }
}
